'use client'

import Link from 'next/link'
import { Fragment } from 'react'

import { Image } from '@/components/Image'
import { SectionContent } from '@/components/SectionContent'
import { SectionHeader } from '@/components/SectionHeader'

export default function Page() {
  return (
    <main className="mb-12 md:mb-20">
      <SectionHeader title="About" subtitle="堀口会計について">
        <p>私たち税理士法人堀口会計は創業から10年。</p>
        <p>
          まだ若い税理士が中心の事務所ですが、これまでに多様な業種・規模のお客様と共に歩んでまいりました。
        </p>
        <p>
          10周年を新たなスタートと捉え、従来の枠にとらわれない挑戦を続けてまいります。
        </p>
        <p>
          AIやクラウド会計などの新しい技術を積極的に取り入れ、中小企業や個人事業主の皆さまが次のステージへ進むための「パートナー」となれるよう努めてまいります。
        </p>
      </SectionHeader>
      {/* MEMBER */}
      <section className="mt-12 md:mt-20">
        <ul className="grid items-start gap-x-12 gap-y-10 px-lg md:grid-cols-2 md:gap-y-20">
          {[
            {
              name: '堀口 拓志',
              position: '名古屋事務所長 | 公認会計士・税理士',
              image: '/horiguchi.jpg',
              career: [
                {
                  date: '平成24年04月',
                  description: '有限責任あずさ監査法人　入社',
                },
                {
                  date: '平成27年10月',
                  description: '税理士法人 堀口会計 設立 代表社員就任',
                },
              ],
              profile:
                '中央大学大学院にて国際財務報告基準（IFRS）の研究を行い、修了後、あずさ監査法人に入所。外資系企業や製造業・小売業をはじめとする幅広い業種の監査を担当し、国際基準に基づく実務経験を積む。2015年に先代の税理士事務所を引き継ぐ形で税理士法人を設立。中小企業から上場関連企業までの税務顧問を行うとともに、幅広い知識を活かし経営を支える税務サービスを提供。また、暗号資産バブル初期より暗号資産関連顧客の対応を行い、申告や会計処理の実務において豊富な実績を有する。複雑化する暗号資産関連の税務においても、最新の制度改正や業界動向を踏まえた実効性のあるアドバイスを行う。',
            },
            {
              name: '岡田 佳祐',
              position: '東京事務所長 | 公認会計士・税理士',
              image: '/okada.jpg',
              career: [
                {
                  date: '平成24年04月',
                  description: '有限責任あずさ監査法人　入社',
                },
                {
                  date: '平成29年12月',
                  description: '税理士法人 堀口会計 東京事務所長　就任',
                },
              ],
              profile:
                '慶応義塾大学を卒業後、あずさ監査法人に入所。あずさ監査法人では主に製造業の監査を担当し、IFRS導入や決算早期化等のアドバイザリー業務にも携わる。あずさ監査法人退所後、Atlas Accountingの前身となる会計事務所にて複数の上場REITに対し決算業務の支援や財務モデリング構築業務等を提供しながら、一般事業会社向けにもIPO支援等の業務を実施している。提携先のAtlas Accountingパートナー就任後は、特に資金調達やITを使用した経理DX支援を強みとした業務を提供している。',
            },
            {
              name: '藤村 大生',
              position: '暗号資産-法人担当 | 公認会計士・税理士',
              image: '/fujimura.jpg',
              career: [
                {
                  date: '平成24年01月',
                  description: '仰星監査法人　入社',
                },
                {
                  date: '令和01年11月',
                  description: 'Aerial税理士法人　社員就任',
                },
              ],
              profile:
                '慶應義塾大学卒業後、仰星監査法人に入所し、ガス業・製造業・小売業などの監査を担当。FAS業務にも従事し、財務DD、株価評価業務なども多く経験している。また、中古車販売会社の役員や個人事務所として会計周りのサポートも行っている。珠算・暗算10段の強みを活かし株式会社あっぷっぷでオンラインそろばん教室を開校し幼児達にそろばんを教えている。暗号資産取引に関する税務については、多数の法人を担当してきた実績を持つ。',
            },
            {
              name: '高嶋 悠也',
              position: '暗号資産-個人担当 | 公認会計士・税理士',
              image: '/takashima.jpg',
              career: [
                {
                  date: '平成24年04月',
                  description: '有限責任あずさ監査法人　入社',
                },
                {
                  date: '平成28年10月',
                  description: '株式会社Atlas Accounting　パートナー就任',
                },
                {
                  date: '令和01年11月',
                  description: 'Aerial税理士法人　社員就任',
                },
                {
                  date: '令和05年10月',
                  description: '税理士法人 堀口会計　社員就任',
                },
              ],
              profile:
                '横浜国立大学卒業後、あずさ監査法人に入所し、製造業・製薬会社・小売業などの監査を担当。独立後は、公認会計士・税理士として、IFRS導入支援や経理体制の構築支援、上場準備企業への経理アドバイザリー、法人・個人の税務業務など幅広い業務に関与している。暗号資産取引に関する税務については、多数の法人・個人案件を担当してきた実績を持つ。',
            },
          ].map((a) => (
            <li
              key={a.name}
              className="grid grid-cols-2 grid-rows-[auto_1fr_auto] items-start gap-x-4 md:gap-x-6"
            >
              <Image
                src={a.image}
                alt={a.name}
                width={600}
                height={600}
                className="md:row-span-2"
              />
              <div>
                <p className="text-xs leading-normal md:mt-1 md:text-sm">
                  {a.position}
                </p>
                <p className="mt-3 font-mincho text-xl font-bold md:mt-4 md:text-2xl">
                  {a.name}
                </p>
              </div>
              <dl className="col-span-2 mt-4 grid grid-cols-[auto_1fr] gap-x-fz-1 gap-y-fz-0.5 text-xs leading-normal text-body-65 md:col-span-1 md:mt-8">
                {a.career.map((b) => (
                  <Fragment key={b.date}>
                    <dt>{b.date}</dt>
                    <dd>{b.description}</dd>
                  </Fragment>
                ))}
              </dl>
              <p className="col-span-2 mt-4 rounded-lg border p-3 text-xs leading-little-loose border-body-20 text-body-65 md:mt-6 md:p-6 md:text-sm">
                {a.profile}
              </p>
            </li>
          ))}
        </ul>
      </section>
      {/* COMPANY */}
      <SectionContent title="事務所概要" className="mt-12 md:mt-20">
        <dl className="inline-grid grid-cols-[auto_1fr] gap-fz-1 text-xs leading-normal md:gap-x-fz-1.5 md:text-sm">
          {[
            {
              name: '事業所名称',
              value: '税理士法人　堀口会計',
            },
            {
              name: '代表社員',
              value: '堀口 拓志',
            },
            {
              name: '所在地(名古屋)',
              value: '〒460-0012 愛知県名古屋市中区千代田二丁目13番9号',
            },
            {
              name: '所在地(東京)',
              value: '〒103-0005 東京都中央区日本橋久松町6番9号',
            },
            {
              name: '在籍資格者',
              value:
                '公認会計士 兼 税理士５名 / 公認会計士１名 / 公認会計士論文式試験合格者１名',
            },
          ].map((a) => (
            <Fragment key={a.name}>
              <dt className="font-semibold">{a.name}</dt>
              <dd>{a.value}</dd>
              <div className="col-span-2 h-0.25 bg-body-10"></div>
            </Fragment>
          ))}
        </dl>
      </SectionContent>
      {/* MAP */}
      <SectionContent title="事務所所在地" className="mt-8 md:mt-12">
        <ul className="grid gap-x-12 gap-y-8 md:grid-cols-2">
          {[
            {
              name: '名古屋事務所',
              address: '〒460-0012\n愛知県名古屋市中区千代田二丁目13番9号',
              map: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3261.9476676355016!2d136.91304701239054!3d35.15792587264726!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x600370b8fb5e4f67%3A0x825806c31cd90dde!2z56iO55CG5aOr5rOV5Lq6IOWggOWPo-S8muioiA!5e0!3m2!1sja!2sjp!4v1770343268990!5m2!1sja!2sjp" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade',
              src: 'https://maps.app.goo.gl/G9xhNsfDKtUsJyyh8',
            },
            {
              name: '東京事務所',
              address: '〒103-0005\n東京都中央区日本橋久松町6番9号',
              map: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d6480.989863585714!2d139.7844469!3d35.689436400000005!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6018894dc28d9a41%3A0x604d3da30f9e298d!2z44CSMTAzLTAwMDUg5p2x5Lqs6YO95Lit5aSu5Yy65pel5pys5qmL5LmF5p2-55S677yW4oiS77yZ!5e0!3m2!1sja!2sjp!4v1770343148731!5m2!1sja!2sjp" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade',
              src: 'https://maps.app.goo.gl/iFbpFRrsWEUxCZVi6',
            },
          ].map((a) => (
            <li key={a.name}>
              <p className="text-sm font-semibold md:text-base">{a.name}</p>
              <p className="mt-fz-1 whitespace-pre-wrap text-xs leading-normal md:text-sm">
                {a.address}
              </p>
              <div className="mt-4 aspect-[2/1] md:mt-6 md:aspect-[4/3]">
                <iframe
                  src={a.map}
                  width="100%"
                  height="100%"
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                ></iframe>
              </div>
              <Link
                href={a.src}
                target="_blank"
                className="mt-3 inline-flex items-center gap-x-0.75 border-b border-current pb-1 text-xxs hover:border-transparent md:mt-4 md:gap-x-1 md:pb-1.5 md:text-xs"
              >
                Google Map
                <span className="material-symbols-outlined !text-[12px]">
                  arrow_forward
                </span>
              </Link>
            </li>
          ))}
        </ul>
      </SectionContent>
    </main>
  )
}
